import { BookConsultationPayload, ConsultationResponse } from '../../types/consultation';

const postToLead = async (path: string, payload: object): Promise<ConsultationResponse | Error> => {
  let isResponseOk: boolean;
  try {
    const response = await fetch(`${window.craftConfig.global.leadServiceUrl}${path}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    isResponseOk = response.ok;
    if (!isResponseOk) {
      let errorMessage = '';
      if (data && data.error?.message) {
        errorMessage = Array.isArray(data.error.message) ? data.error.message[0] : data.error.message;
      }
      if (errorMessage.indexOf('Slot') !== -1) {
        errorMessage = 'taken';
      } else if (errorMessage.indexOf('iban') !== -1) {
        errorMessage = 'iban invalid';
      } else {
        errorMessage = `error: ${errorMessage || ''}`;
      }
      throw new Error(errorMessage);
    }
    if (data.uid) {
      setUidCookie(data.uid);
    } else if (data.leadId) {
      setUidCookie(data.leadId);
    }
    return data as ConsultationResponse;
  } catch (error) {
    return error as Error;
  }
};
export default postToLead;

export async function submitConsultationLead(payload: BookConsultationPayload) {
  const response = await postToLead('/protected/consultation', payload);
  return response as ConsultationResponse;
}

/**
 * Sets a cookie named "_uid" with the given data as its value.
 * The cookie expires after one year.
 * The cookie's domain is set based on the current window's location hostname.
 *
 * @param {string} data - The data to be stored in the cookie.
 */
export function setUidCookie(data: string): void {
  // Set the cookie's expiration date to one year from now
  const date = new Date();
  date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);

  // Format the cookie's expiration date
  const expires = `; expires=${date.toUTCString()}`;

  // Set the cookie's domain based on the current window's location hostname
  let cookieDomain = window.location.hostname;
  if (cookieDomain.indexOf('ottonova.de') > -1) {
    cookieDomain = 'ottonova.de';
  } else if (cookieDomain.indexOf('test.on.ag') > -1) {
    cookieDomain = 'test.on.ag';
  } else if (cookieDomain.indexOf('staging.on.ag') > -1) {
    cookieDomain = 'staging.on.ag';
  }

  // Set the cookie with the given data
  if ('cookieStore' in window) {
    cookieStore
      .set({
        name: '_uid',
        value: data,
        expires: date.getTime(),
        domain: cookieDomain
      })
      .catch(err => (window as any).Sentry?.captureException(err));
    return;
  }
  document.cookie = `_uid=${data}${expires}; path=/; domain=${cookieDomain}`;
}
